import React, { useEffect, useState } from "react";
import axiosStrapiInstance from "../../axiosStrapi";
import { toast } from "react-toastify";
import SelectComponent from "./SelectComponent";
import CustomButton from "./CustomButton";

const EnquiryForm = ({ width, paddingX, enquirySource }) => {
  const [branches, setBranches] = useState([]);
  const initialValues = {
    interest: "",
    branch: "",
    name: "",
    childName: "",
    email: "",
    phone: "",
    message: "",
    dateOfBirth: "",
  };
  const [formData, setFormData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get(
          "/api/branches?populate=*&sort=branch_id:asc&filters[branchType][$ne]=Other"
        );
        setBranches(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const branchesOption = branches?.map((item) => ({
    label: item?.name,
    value: item?.documentId,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.interest ||
      !formData.branch ||
      !formData.name ||
      !formData.childName ||
      !formData.email ||
      !formData.phone ||
      !formData.message ||
      !formData.dateOfBirth
    ) {
      toast.error("Fill All the Details");
      return;
    }
    try {
      setLoading(true);
      if (formData?.phone?.length !== 10) {
        toast.error("Phone No should be of 10 digits");
        return;
      }
      formData.EnquirySource = enquirySource ?? "ContactUs";
      const payload = { data: formData };
      const response = await axiosStrapiInstance.post(
        "/api/enquiries",
        payload
      );
      setFormData(initialValues);
      toast.success("form Submitted Successfully");
    } catch (error) {
      console.log("error while submiting form", error);
      toast.error(error?.response?.data?.error?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`lg:w-1/2 z-20 font-Lato bg-white rounded-lg p-3 sm:p-4 sm:py-3 shadow-md`}
      style={{
        width: width ? width : "50%",
        padding: paddingX && `15px ${paddingX}`,
      }}
    >
      <h2 className=" font-Lato text-[32px] leading-10 text-[#121212] sm:mt-5 mt-0 font-bold mb-3 sm:mb-6">
        Enquiry Form
      </h2>
      <form onSubmit={handleSubmit} className="space-y-[10px]">
        <div className="grid self-start grid-cols-1 sm:grid-cols-2 gap-3 ">
          <div className="">
            <label className="block text-left text-[#D31C4F] mb-1">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
              placeholder="Enter Name"
            />
          </div>

          <div>
            <label className="block text-left text-[#D31C4F] mb-1">Child's Name</label>
            <input
              type="text"
              name="childName"
              value={formData.childName}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
              placeholder="Enter Name"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="block text-left text-[#D31C4F] mb-1">
              Child Date Of Birth
            </label>
            <input
              type="date"
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={handleChange}
              onKeyDown={(e) => e.preventDefault()}
              className="w-full border border-gray-300 min-h-[34px] sm:min-w-full min-w-[300px] rounded-lg p-2"
              placeholder="Enter DOB"
            />
          </div>
          <div>
            <label className="block text-left text-[#D31C4F] mb-1 ">Select Branch</label>
            <SelectComponent
              borderRadius={"8px"}
              options={branchesOption}
              name="branch"
              height={"45px"}
              value={formData?.branch}
              placeholder={"Select Branch"}
              className="w-full scrollbar-hidden"
              handleChange={handleSelectChange}
            />
          </div>
        </div>

        <div>
          <label className="block text-left text-[#D31C4F] mb-1">I'm Interested In</label>
          <SelectComponent
            borderRadius={"8px"}
            options={[
              { label: "Admission", value: "Admission" },
              { label: "Fee", value: "Fee" },
              {
                label: "Documents Required",
                value: "Documents Required",
              },
            ]}
            name={"interest"}
            placeholder="Interest"
            className="w-full"
            handleChange={handleSelectChange}
          />
        </div>

        <div>
          <label className="block text-left text-[#D31C4F] mb-1">Email ID</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2"
            placeholder="Enter Email Address"
          />
        </div>

        <div>
          <label className="block text-left text-[#D31C4F] mb-1">Phone No.</label>
          <input
            type="number"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2"
            placeholder="Enter No."
          />
        </div>

        <div>
          <label className="block text-left text-[#D31C4F] mb-1">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2"
            placeholder="Write your enquiry (if any)"
            rows="4"
          ></textarea>
        </div>

        <CustomButton
          text={"Submit"}
          disabled={loading}
          paddingX="30px"
          paddingY="12px"
        />
      </form>
    </div>
  );
};

export default EnquiryForm;
